export const LOCALE_COOKIE = 'NEXT_LOCALE'
